import XLSX from 'xlsx'
//Order Functions
function convertOrdersList(list) {
  let newList = []
  list.forEach((row) => {
    let newRow = {
      pedido: row['Relatório de Pedidos'], //1
      dataPedido: row.__EMPTY, //2
      hora: row.__EMPTY_1, //3
      subtotalDeProdutos: row.__EMPTY_2, //4
      impostos: row.__EMPTY_3, //5
      localVenda: row.__EMPTY_4, //6
      frete: row.__EMPTY_5, //7
      valorFrete: row.__EMPTY_6, //8
      pagamento1: row.__EMPTY_7, //9
      formaPagamentoEscolhida: row.__EMPTY_8, //10
      dataEnvios: row.__EMPTY_9, //11
      codEnvio: row.__EMPTY_10, //12
      obsCliente: row.__EMPTY_11, //13
      obsLoja: row.__EMPTY_12, //14
      status: row.__EMPTY_13, //15
      parceiro: row.__EMPTY_14, //16
      valorComissao: row.__EMPTY_15, //17
      cupomDesconto: row.__EMPTY_16, //18
      desconto: row.__EMPTY_17, //19
      acrescimoForma: row.__EMPTY_18, //20
      idCliente: row.__EMPTY_19, //21
      cliente: row.__EMPTY_20, //22
      apelido: row.__EMPTY_21, //23
      rg: row.__EMPTY_22, //24
      cpf: row.__EMPTY_23, //25
      email: row.__EMPTY_24, //26
      telefone: row.__EMPTY_25, //27
      telefone2: row.__EMPTY_26, //28
      razao: row.__EMPTY_27, //29
      cnpj: row.__EMPTY_28, //30
      ie: row.__EMPTY_29, //31
      destinatario: row.__EMPTY_30, //32
      endereco: row.__EMPTY_31, //33
      num: row.__EMPTY_32, //34
      cidade: row.__EMPTY_33, //35
      estado: row.__EMPTY_34, //36
      cep: row.__EMPTY_35, //37
      complemento: row.__EMPTY_36, //38
      bairro: row.__EMPTY_37, //39
      pais: row.__EMPTY_38, //40
      dataPagamento: row.__EMPTY_39, //41
      valorPgto: row.__EMPTY_40, //42
      formaPagamentoPaga: row.__EMPTY_41, //43
      enderecoCobranca: row.__EMPTY_42, //44
      numCobranca: row.__EMPTY_43, //45
      cidadeCobranca: row.__EMPTY_44, //46
      estadoCobranca: row.__EMPTY_45, //47
      cepCobranca: row.__EMPTY_46, //48
      complementoCobranca: row.__EMPTY_47, //49
      bairroCobranca: row.__EMPTY_48, //50
      paisCobranca: row.__EMPTY_49, //51
      cartoes: row.__EMPTY_50, //52
      vendedorDoMercadolivre: row.__EMPTY_51, //53
      warnings: [],
    }
    // verifyOrderWarnings(newRow)

    newList.push(newRow)
  })

  return newList
}

function verifyOrderWarnings(row) {
  let warning = null
  if (row.cliente?.length > 35)
    warning = actAddOrderWarning(row, 'cliente', 'NOME', 35)
  if (row.razao?.length > 80)
    warning = actAddOrderWarning(row, 'razao', 'RAZAOSOCIAL', 80)
  if (row.bairro?.length > 45)
    warning = actAddOrderWarning(row, 'bairro', 'BAIRRO', 45)
  if (row.num?.length > 8) warning = actAddOrderWarning(row, 'num', 'NUMERO', 8)
  if (row.complemento?.length > 25)
    warning = actAddOrderWarning(row, 'complemento', 'COMPLEMENTO', 25)
  if (row.endereco?.length > 45)
    warning = actAddOrderWarning(row, 'endereco', 'ENDERECO', 45)

  // vCodigoMunicipio := actConsultaGenerica('CIDADES',
  //   actRemoveAcentos(cdsPedidosCIDADE.AsString).ToUpper, 'DESCRICAO',
  //   'CODIGOMUNICIPIO');

  // if vCodigoMunicipio.Length <= 0
  // begin
  //   actAddMessage('[ERRO] Código Municipio não encontrado. >> Pedido: ' +
  //     cdsPedidosPEDIDO.AsString + ' | Cidade: ' +
  //     cdsPedidosCIDADE.AsString.ToUpper);

  // end;

  if (row.cidade?.length > 35)
    warning = actAddOrderWarning(row, 'cidade', 'CIDADE', 35)
  if (row.telefone?.length > 16)
    warning = actAddOrderWarning(row, 'telefone', 'FONE', 16)
  if (row.telefone2?.length > 16)
    warning = actAddOrderWarning(row, 'telefone2', 'FONE1', 16)
  if (row.email?.length > 60)
    warning = actAddOrderWarning(row, 'email', 'EMAIL', 60)

  return warning
}

function convertOrdersHeader(header) {
  header.forEach((column) => {
    column.value = getEqualOrderHeader(column.value)
  })
}

function getEqualOrderHeader(string) {
  switch (string) {
    case 'warnings':
      return 'warnings'
    case 'Relatório de Pedidos':
      return 'pedido'
    case '__EMPTY':
      return 'dataPedido'
    case '__EMPTY_1':
      return 'hora'
    case '__EMPTY_2':
      return 'subtotalDeProdutos'
    case '__EMPTY_3':
      return 'impostos'
    case '__EMPTY_4':
      return 'localVenda'
    case '__EMPTY_5':
      return 'frete'
    case '__EMPTY_6':
      return 'valorFrete'
    case '__EMPTY_7':
      return 'pagamento1'
    case '__EMPTY_8':
      return 'formaPagamentoEscolhida'
    case '__EMPTY_9':
      return 'dataEnvios'
    case '__EMPTY_10':
      return 'codEnvio'
    case '__EMPTY_11':
      return 'obsCliente'
    case '__EMPTY_12':
      return 'obsLoja'
    case '__EMPTY_13':
      return 'status'
    case '__EMPTY_14':
      return 'parceiro'
    case '__EMPTY_15':
      return 'valorComissao'
    case '__EMPTY_16':
      return 'cupomDesconto'
    case '__EMPTY_17':
      return 'desconto'
    case '__EMPTY_18':
      return 'acrescimoForma'
    case '__EMPTY_19':
      return 'idCliente'
    case '__EMPTY_20':
      return 'cliente'
    case '__EMPTY_21':
      return 'apelido'
    case '__EMPTY_22':
      return 'rg'
    case '__EMPTY_23':
      return 'cpf'
    case '__EMPTY_24':
      return 'email'
    case '__EMPTY_25':
      return 'telefone'
    case '__EMPTY_26':
      return 'telefone2'
    case '__EMPTY_27':
      return 'razao'
    case '__EMPTY_28':
      return 'cnpj'
    case '__EMPTY_29':
      return 'ie'
    case '__EMPTY_30':
      return 'destinatario'
    case '__EMPTY_31':
      return 'endereco'
    case '__EMPTY_32':
      return 'num'
    case '__EMPTY_33':
      return 'cidade'
    case '__EMPTY_34':
      return 'estado'
    case '__EMPTY_35':
      return 'cep'
    case '__EMPTY_36':
      return 'complemento'
    case '__EMPTY_37':
      return 'bairro'
    case '__EMPTY_38':
      return 'pais'
    case '__EMPTY_39':
      return 'dataPagamento'
    case '__EMPTY_40':
      return 'valorPgto'
    case '__EMPTY_41':
      return 'formaPagamentoPaga'
    case '__EMPTY_42':
      return 'enderecoCobranca'
    case '__EMPTY_43':
      return 'numCobranca'
    case '__EMPTY_44':
      return 'cidadeCobranca'
    case '__EMPTY_45':
      return 'estadoCobranca'
    case '__EMPTY_46':
      return 'cepCobranca'
    case '__EMPTY_47':
      return 'complementoCobranca'
    case '__EMPTY_48':
      return 'bairroCobranca'
    case '__EMPTY_49':
      return 'paisCobranca'
    case '__EMPTY_50':
      return 'cartoes'
    case '__EMPTY_51':
      return 'vendedorDoMercadolivre'
  }
}

function prepareOrderObject(order) {
  return {
    NUMERO: order.pedido || 0,
    DATA: order.dataPedido || '01/01/2001',
    HORA: order.hora || '00:00:01',
    VALOR: order.subtotalDeProdutos || 0,
    IMPOSTOS: order.impostos || 0,
    LOCAL_VENDA: order.localVenda || '',
    FRETE_NOME: order.frete || '',
    VALORFRETE: order.valorFrete || 0,
    FORMAPAGAMENTO: order.formaPagamentoEscolhida || '',
    DATAENTREGA: order.dataEnvios || '01/01/2001',
    CODIGOENVIO: order.codEnvio || '',
    OBS_LOJA: order.obsLoja || '',
    STATUS: order.status || '',
    ACRESCIMOFORMAPAGAMENTO: order.acrescimoForma || 0,
    CODIGO: order.idCliente || 0,
    DATAPAGAMENTO: order.dataPagamento || '01/01/2001',
    VALORPAGAMENTO: order.valorPgto || 0,
    CUPOM_DESCONTO: order.cupomDesconto || '',
    itens: prepareItemObject(order.items),
    empresa: prepareCompanyObject(order),
  }
}

//Item Functions
function convertItemsList(list) {
  let newList = []
  list.forEach((row) => {
    newList.push({
      pedido: row['Relatório de Pedidos'],
      idProduto: row.__EMPTY,
      idVariacao: row.__EMPTY_1,
      produto: row.__EMPTY_2,
      custo: row.__EMPTY_3,
      preco: row.__EMPTY_4,
      quantidade: row.__EMPTY_5,
      referencia: row.__EMPTY_6,
      informacaoAdicional: row.__EMPTY_7 ?? undefined,
      warnings: [],
    })
  })
  return newList
}

function convertItemsHeader(header) {
  ''
  header.forEach((column) => {
    column.value = getEqualItemHeader(column.value)
  })
}

function getEqualItemHeader(string) {
  switch (string) {
    case 'warnings':
      return 'warnings'
    case 'Relatório de Pedidos':
      return 'pedido' //1
    case '__EMPTY':
      return 'idProduto' //2
    case '__EMPTY_1':
      return 'idVariacao' //3
    case '__EMPTY_2':
      return 'produto' //4
    case '__EMPTY_3':
      return 'custo' //5
    case '__EMPTY_4':
      return 'preco' //6
    case '__EMPTY_5':
      return 'quantidade' //7
    case '__EMPTY_6':
      return 'referencia' //8
    case '__EMPTY_7':
      return 'informacaoAdicional' //9
    default:
      return undefined
  }
}

function prepareItemObject(items) {
  return items.map((item) => ({
    ITEM: item.referencia,
    NUMEROEXPORTADO: item.pedido,
    QUANTIDADE: item.quantidade,
    PRECO: item.preco,
    COMPLEMENTODESCRICAO: item.produto,
    ID_VARIACAO: item.idVariacao,
  }))
}

//Company Functions

function prepareCompanyObject(order) {
  return {
    CODIGO: order.idCliente || 0,
    NOME: order.cliente || '',
    RG: order.rg || '',
    CPF: order.cpf || '',
    EMAIL: order.email || '',
    FONE: order.telefone || '',
    FONE1: order.telefone2 || '',
    RAZAOSOCIAL: order.razao || '',
    CNPJ: order.cnpj || '',
    IE: order.ie || '',
    ENDERECO: order.endereco || '',
    NUMERO: order.num || '',
    CIDADE: order.cidade || '',
    UF: order.estado || '',
    CEP: order.cep || '',
    COMPLEMENTO: order.complemento || '',
    BAIRRO: order.bairro || '',
    PAIS: order.pais || '',
    ENDERECOCOBRANCA: order.enderecoCobranca || '',
    NUMEROCOBRANCA: order.numCobranca || '',
    CIDADECOBRANCA: order.cidadeCobranca || '',
    UFCOBRANCA: order.estadoCobranca || '',
    COMPLEMENTOCOBRANCA: order.complementoCobranca || '',
    BAIRROCOBRANCA: order.bairroCobranca || '',
    PAISCOBRANCA: order.paisCobranca || '',
  }
}

//General Functions
function actAddOrderWarning(order, field, fieldDB, maxLength) {
  return {
    orderId: order.pedido,
    field: fieldDB,
    value: order[field],
    size: order[field].length,
    text:
      ' [' +
      order[field].length.toString() +
      '] | Max [' +
      maxLength.toString() +
      ']',
  }
}

// function fillSizeRules(field, value) {
//   switch (field) {
//     case 'cliente':
//       return value && value.length > 35
//     case 'razao':
//       return value && value.length > 80
//     case 'bairro':
//       return value && value.length > 45
//     case 'num':
//       return value && value.length > 8
//     case 'complemento':
//       return value && value.length > 25
//     case 'endereco':
//       return value && value.length > 45
//     case 'cidade':
//       return value && value.length > 35
//     case 'telefone':
//       return value && value.length > 16
//     case 'telefone2':
//       return value && value.length > 16
//     case 'email':
//       return value && value.length > 60
//     default:
//       return false
//   }
// }

function generateXlsxFile(data, filename) {
  let sheet = this.generateSheetXlsx(data)
  this.generateFile(sheet, filename)
}

function generateSheetXlsx(data) {
  return XLSX.utils.json_to_sheet(data)
}

function generateFile(sheet, filename) {
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, sheet)
  XLSX.writeFile(wb, `${filename}.xlsx`)
}

export {
  verifyOrderWarnings,
  convertOrdersList,
  convertOrdersHeader,
  prepareOrderObject,
  convertItemsList,
  convertItemsHeader,
  prepareItemObject,
  prepareCompanyObject,
  generateXlsxFile,
  generateSheetXlsx,
  generateFile,
}
